export enum CustomerSpecificRoutes {
  TEACHERS = 'teachers',
}
